module.exports = { id: "switch", url: "/build/app/img/symbols.svg#switch", viewBox: "", toString: function() { return this.url; } };